import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { UCSystemType, SystemGraphModel, BarGraphView, ComponentGraphModel, QuoteOverviewModel, RecommendationModel, ComponentModel } from '../../models/interpretation.model';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';import { AddRecommendationComponent } from '../add-recommendation/add-recommendation.component';
import { QuoteService } from '../../quote-service.service';
import { BarGraphService } from '../../bar-graph.service';
import { Subscription } from 'rxjs/Subscription';
import { EditRecommendationComponent } from '../edit-recommendation/edit-recommendation.component';
import { Side } from '../../../../entities';
import { UserService } from '../../../../shared/services/user.service';
import { SetupUndercarriageService } from '../../../../modules/setup-undercarriage';
import { AppService } from '../../../../app.service';
import { CustomeEvaluationRangeVM } from '../../../../modules/CustomEval/custom-eval.model';

@Component({
  selector: 'system-graph',
  templateUrl: './system-graph.component.html',
  styleUrls: ['./system-graph.component.scss']
})
export class SystemGraphComponent implements OnInit, OnDestroy {
  @Input() inspectionId: number = -1;
  @Input() systemId: number = -1;
  @Input() selectedQuoteId: number = -1;
  @Input() Family_ :string
  intervalPixelWidth: number = 300; // Width between intervals in pixels
  smuInterval: number = 1000;       // SMU interval in hours
  zoomScale: number = 1;            // The zoom scale to apply to the bar sizes
  view: BarGraphView;
  @Output() reloadSelectedQuote: EventEmitter<any> = new EventEmitter();
  BarGraphView = BarGraphView;
  quotes: QuoteOverviewModel[] = [];

  system: SystemGraphModel = new SystemGraphModel();
  loadingSystems: boolean = true;
  side: string = "Left";
  type: string = "Chain";

  subscriptions: Subscription[] = [];
  isInspector: boolean = false;
  isInterpreter: boolean = false;
  @Input() EvalautionRange:CustomeEvaluationRangeVM;
  constructor(private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog,
    private _quotes: QuoteService,
    private _bar: BarGraphService,
  private _user: UserService,
  private _setupService: SetupUndercarriageService,
  private _app: AppService) { }

  ngOnInit() {
    /**
     * Need to surround these in a set timeout or the component will
     * get errors when re-initializing. 
     */
    setTimeout(() => {
      this.checkPermissions();
      this.loadQuotes();
      this.initializeSystemComponentData();
      this.initializeGraphs();    
    });
  }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case "Inspectors":
              this.isInspector = true;
              break;
            case "Interpreters":
            case "Super User":
            case "Administrator":
              this.isInterpreter = true;
              this.isInspector = true;
              break;
          }
        })
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }
  GetEvalColour(comp: ComponentModel, worn: number) {
    var compType = comp.ComponentTypeId;

    //console.log("compType", compType)
    //console.log("EvalautionRange", this.EvalautionRange)
    switch (compType) {
      case 230: //Link
        if (this.EvalautionRange.LinkC != null) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

        case 231://Bush
          if (this.EvalautionRange.BushC != null) {
            if (worn <= this.EvalautionRange.BushA)
              return 'Eval-A';
            else if (worn <= this.EvalautionRange.BushB)
              return 'Eval-B';
            else if (worn <= this.EvalautionRange.BushC)
              return 'Eval-C';
            else
              return 'Eval-X';
          } else {
            if (worn <= this.EvalautionRange.BushA)
              return 'Eval-A';
            else if (worn <= this.EvalautionRange.BushB)
              return 'Eval-B';
            else
              return 'Eval-X';
          }
        
          case 232: //Shoe
            if (this.EvalautionRange.ShoeC != null) {
              if (worn <= this.EvalautionRange.ShoeA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.ShoeB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.ShoeC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.ShoeA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.ShoeB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 233://Idler
            if (this.EvalautionRange.LinkC != null) {
              if (worn <= this.EvalautionRange.LinkA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.LinkB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.LinkC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.LinkA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.LinkB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 234://carrier Roller
            if (this.EvalautionRange.CarrierRollerC != null) {
              if (worn <= this.EvalautionRange.CarrierRollerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.CarrierRollerB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.CarrierRollerC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.CarrierRollerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.CarrierRollerB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 235://track Roller
            if (this.EvalautionRange.TrackRollerC != null) {
              if (worn <= this.EvalautionRange.TrackRollerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.TrackRollerB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.TrackRollerC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.TrackRollerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.TrackRollerB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }
            case 236://Sprokcket
            if (this.EvalautionRange.SprocketC != null) {
              if (worn <= this.EvalautionRange.SprocketA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.SprocketB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.SprocketC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.SprocketA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.SprocketB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 240://Elognation
            if (this.EvalautionRange.ElongationC != null) {
              if (worn <= this.EvalautionRange.ElongationA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.ElongationB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.ElongationC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.ElongationA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.ElongationB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 417://Crawler
            if (this.EvalautionRange.CrawlerGuideC != null) {
              if (worn <= this.EvalautionRange.CrawlerGuideA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.CrawlerGuideB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.CrawlerGuideC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.CrawlerGuideA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.CrawlerGuideB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 446://RSREAR
            if (this.EvalautionRange.RSRearIdlerC != null) {
              if (worn <= this.EvalautionRange.RSRearIdlerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.RSRearIdlerB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.RSRearIdlerC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.RSRearIdlerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.RSRearIdlerB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }
      default:
        break;
    }
  }
  /**
   * Wrap the load system call within the get quote subscription so that
   * every time a user changes a quote the recommendations reload on the graph
   * view.
   *
   * This is definitely not a great implementation but I've run out of time to
   * re-factor it.. 
   */
  initializeSystemComponentData() {
    this._quotes.getQuoteOverviews().subscribe(q => {
      this.loadSystem();
    });
    this._quotes.reloadQuoteOverview(this.inspectionId);
  }

  /**
   * Unsubscribe from all subscriptions when destroying the
   * component. 
   */
  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      if (!s.closed)
        s.unsubscribe();
    });
  }

  /**
   * Subscribe to the graph tool box buttons for manipulating the zoom distance and SMU
   * interval displayed. 
   */
  initializeGraphs() {
    this.subscriptions.push(this._bar.getZoomScale().subscribe(scale => this.zoomScale = scale));
    this.subscriptions.push(this._bar.getSmuInterval().subscribe(smuInterval => { this.smuInterval = smuInterval; }));
    this.subscriptions.push(this._bar.getBarGraphView().subscribe(view => this.view = view));

    this.getFamilyDetails(this.Family_);
  }

  /**
   * Returns the width of each hour as it's pixel value for displaying on the page. 
   */
  get hourPerPixel(): number {
    return (this.intervalPixelWidth / this.smuInterval) / this.zoomScale;
  }

  /**
   * Returns an array the size of the intervals. This is purely used
   * so that the ngFor loop in the template can create the correct
   * number of intervals needed. Yes I agree this is a stupid solution but
   * I can't find a better one.
   */
  getIntervalCount(): number[] {
    let count = Math.ceil(((this.getMaximumVisibleSmu() - this.minimumVisibleSmu) / this.smuInterval));
    let ret = [];
    for (let i = 0; i < count; i++) {
      ret.push(i);
    }
    return ret;
  }

  /**
   * Returns the lowest SMU number to be displayed along the X axis of the bar chart
   */
  get minimumVisibleSmu(): number {
    let smu: number = this.system.InspectionSmu;

    this.system.Components.forEach(c => {
      if (c.SmuAtInstall < smu) smu = c.SmuAtInstall;
    });
    return smu;
  }

  /**
   * Returns the highest SMU number to be displayed along the X axis of the bar chart
   */
  getMaximumVisibleSmu(): number {
    let smu: number = this.system.InspectionSmu;
    this.system.Components.forEach(c => {
      if ((c.RisidualLife120 + this.system.InspectionSmu + c.Cmu) > smu) smu = c.RisidualLife120 + this.system.InspectionSmu + c.Cmu;
    });

    return smu;
  }

  /**
   * Returns the width between intervals along the X axis of the bar chart.
   * This value is in pixals. 
   */
  getIntervalWidth(): number {
    return this.intervalPixelWidth / this.zoomScale;
  }

  /**
   * Gets the extra hours gained between a component been worn at 100% and 120%.
   * We use this so that the extra hours displayed in the graph for 120% worn are only
   *  those extra hours, not the whole entire life of the component as well. 
   * @param componentId The component Id to get the hours for. 
   */
  getComponentWorn120Hours(componentId: number): number {
    let component = this.system.Components.find(c => c.ComponentId == componentId);
    return component.RisidualLife120 - component.RisidualLife100;
  }

  /**
   * Gets a component object with useful data. 
   * @param componentId The ID of the component you want to get. 
   */
  getComponent(componentId: number): ComponentGraphModel {
    return this.system.Components.find(c => c.ComponentId == componentId);
  }

  /**
   * Opens the add recommendation popup for the given component id. 
   * @param componentId The component Id we want to add a recommendation for. 
   */
  openAddRecommendation(componentId: number) {
    let addRecommendationModalRef = this._dialog.open(AddRecommendationComponent, {
      data: {
        inspectionId: this.inspectionId,
        componentId: componentId,
        quoteId: this.selectedQuoteId
      }
    });
    addRecommendationModalRef.afterClosed().subscribe(details => {
      if (details != null)
        this._quotes.reloadQuoteOverview(this.inspectionId);
    })
  }

  /**
   * Gets the position the red vertical inspection bar should be displayed at on
   * the bar graph. (The distance in pixels from the left of the graph). 
   */
  get inspectionLinePosition(): number {
    return (this.system.InspectionSmu - this.minimumVisibleSmu) * this.hourPerPixel
  }

  /**
   * Get the pixel value for the left of the bar to determine
   * where the hours done bar should start on the graph. 
   * @param componentId The component ID we are drawing the bar for. 
   */
  getHoursDoneLeftPixels(componentId: number): number {
    let component = this.getComponent(componentId);
    let smuAtInstall = component.SmuAtInstall;
    return (smuAtInstall - this.minimumVisibleSmu) * this.hourPerPixel;
  }

  /**
   * Get the pixel width the hours done bar should be. 
   * @param componentId The component ID we are drawing the bar for. 
   */
  getHoursDoneWidthPixels(componentId: number): number {
    let component = this.getComponent(componentId);
    let cmu = component.Cmu;
    return (cmu - component.CmuAtInstall) * this.hourPerPixel;
  }

   /**
   * Get the pixel value for the left of the bar to determine
   * where the hours remaining bar should start on the graph. 
   * @param componentId The component ID we are drawing the bar for. 
   */
  getHoursRemaining100LeftPixels(componentId: number): number {
    let component = this.getComponent(componentId);
    let smuAtInstall = component.SmuAtInstall;
    let cmu = component.Cmu;
    return ((smuAtInstall + cmu - this.minimumVisibleSmu - component.CmuAtInstall) * this.hourPerPixel);
  }

  /**
   * Get the pixel width the hours remaining bar should be. 
   * @param componentId The component ID we are drawing the bar for. 
   */
  getHoursRemaining100WidthPixels(componentId: number): number {
    let component = this.getComponent(componentId);
    let residualLife100 = component.RisidualLife100;
    return (residualLife100 - component.CmuAtInstall) * this.hourPerPixel;
  }

   /**
   * Get the pixel value for the left of the bar to determine
   * where the hours remaining 120% bar should start on the graph. 
   * @param componentId The component ID we are drawing the bar for. 
   */
  getHoursRemaining120LeftPixels(componentId: number): number {
    let component = this.getComponent(componentId);
    let smuAtInstall = component.SmuAtInstall;
    let cmu = component.Cmu;
    let residualLife100 = component.RisidualLife100;
    return this.getHoursRemaining100LeftPixels(componentId) + this.getHoursRemaining100WidthPixels(componentId);
  }

  /**
   * Get the pixel width the hours remaining 120% bar should be. 
   * @param componentId The component ID we are drawing the bar for. 
   */
  getHoursRemaining120WidthPixels(componentId: number): number {
    let component = this.getComponent(componentId);
    let residualLife100 = component.RisidualLife100;
    let residualLife120 = component.RisidualLife120;
    return ((residualLife120 - residualLife100 - component.CmuAtInstall) * this.hourPerPixel);
  }

  /**
   * Gets the system data from the server
   */
  loadSystem() {
    this._interp.getSystemGraph(this.inspectionId, this.systemId).subscribe(system => {
      this.system = system;
      this.loadingSystems = false;
    });
  }

  /**
   * Gets the title of the panel. This title will be the type of the system (Chain/Frame)
   * and the side of the equipment that system is on. 
   */
  get panelHeading() {
    if (this.loadingSystems)
      return "";
    return this.systemSide + ' Side ' + this.systemName;
  }

  /**
   * Get a list of all recommendations within the currently selected
   * Quote for the given component ID.
   * @param componentId The component ID to get recommendations for. 
   */
  getComponentRecommendations(componentId: number): RecommendationModel[] {
    let c = this.getComponent(componentId);
    return c.Recommendations.filter(c => c.QuoteId == this.selectedQuoteId);
  }

  /**
   * Get the width the given recommendation bar should be in pixels. 
   * @param componentId The ID of the component this recommendation is for. 
   * @param recommendationId The ID of the recommendation we are calculating the width for. 
   */
  getRecommendationWidthPixels(componentId: number, recommendationId: number): number {
    let r = this.system.Components.find(c => c.ComponentId == componentId).Recommendations.find(r => r.RecommendationId == recommendationId);
    return (r.CompleteActionBySmu - r.StartActionAtSmu) * this.hourPerPixel;
  }

  /**
   * Gets the left position in pixels the recommendation bar should start
   * at relative to the start of the bar graph. 
   * @param componentId The ID of the component this recommendation is for.
   * @param recommendationId The ID of the recommendation we are calculating the left position for.
   */
  getRecommendationLeftPixels(componentId: number, recommendationId: number): number {
    let r = this.system.Components.find(c => c.ComponentId == componentId).Recommendations.find(r => r.RecommendationId == recommendationId);
    return (r.StartActionAtSmu - this.minimumVisibleSmu) * this.hourPerPixel;
  }

  /**   
   * Gets the name as text of the system based on it's type. 
   * @returns Chain or Frame depending on the system type. 
   */
  get systemName() {
    switch (this.system.Type) {
      case UCSystemType.Chain:
        return "Chain";
      case UCSystemType.Frame:
        return "Frame";
      default:
        return "Chain";
    }
  }

  /**
   * Gets the name of the side of the equipment that
   * this system is on. 
   * @returns The side of the system. 
   */
  get systemSide(): string {
    switch (this.system.Side) {
      case Side.Unknown: return 'Unknown';
      case Side.Both: return 'Both';
      case Side.Left: return 'Left';
      case Side.Right: return 'Right';
    }
  }

  /**
   * Opens the edit recommendation modal. 
   * @param componentId The component ID this recommendation we are editing is for. 
   * @param recommendationId The ID of the recommendation we are editing. 
   */
  openEditRecommendation(componentId: number, recommendationId: number) {
    let editRecommendationModalRef = this._dialog.open(EditRecommendationComponent, {
      data: {
        inspectionId: this.inspectionId,
        componentId: componentId,
        quoteId: this.selectedQuoteId,
        recommendationId: recommendationId,
      }
    });
    editRecommendationModalRef.afterClosed().subscribe(recommendation => {
      if (recommendation != null)
        this._quotes.reloadQuoteOverview(this.inspectionId);
    })
  }

  /**
   * Sanitizes the image (in base 64 string format) so that we can display it
   * in the html template of the component. 
   * @param image The image in base 64 string format. 
   */
  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(image);
  }


  loadQuotes() {
    this._quotes.getQuoteOverviewsAndReloadIfFirst(this.inspectionId).subscribe(r => {
      this.quotes = r;
    });
  }


  
  componentHasRecommendation(componentId: number): boolean {
    let quote = this.quotes.find(q => q.QuoteId == this.selectedQuoteId);
    if (quote == null)
      return false;
    let recommendation = quote.Recommendations.find(q => q.ComponentId == componentId);
    if (recommendation != null)
      return true;
    return false;
  }

  getImage_(image: string) {
    if(image != null)
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
    else if(this.systemName =='Frame'){
      return "/Content/Images/frame.jpg";
    }else
     return "/Content/Images/chain.jpg";
  }

  FamilyImage_Chain: string 
  FamilyImage_Frame: string 
  getFamilyDetails(value: string) {
    this._setupService.getFamilyList().subscribe(res => {
      if (res != null) {
        let familydetails = res
          familydetails.map(x => {
            if (x.typedesc == value) {
              this.FamilyImage_Chain = x.ChainImage
              this.FamilyImage_Frame = x.FrameImage
            }
          })
        }
    })
  }

  getChildRowPosition(componentId: number): string {
    const component = this.getComponent(componentId);
    //console.log("component",component)
    const children = this.system.Components.filter(c => c.ComponentTypeId === component.ComponentTypeId && c.IsChild);
    if (children[0].ComponentId === componentId) return '--extended';
    if (children[children.length - 1].ComponentId === componentId) return '--half';
    return '';
  }

  showPosition(position: number, compartTypeId: number): string {
    //console.log("POsistion",position,compartTypeId)
    let hasSameComponent = this.system.Components.filter(x=>x.ComponentTypeId==compartTypeId && x.IsChild==false);
    if(hasSameComponent.length>1){
      return this.getPositionStringDoubleComponents(position,compartTypeId);
    }else{
      return this._app.getPositionString(position, compartTypeId);
    }
    // if(this.system.Components.length >4){
    //         return this.getPositionStringDoubleComponents(position,compartTypeId);
    // }else{
    //     return this._app.getPositionString(position, compartTypeId);
    // }
   
}

getPositionStringDoubleComponents(Pos: number, CompartTypeId: number): string {
  if (CompartTypeId === 233) // Idler
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
  if (CompartTypeId === 234 && Pos === 1) // Carrier roller
      return 'Front';
  if (CompartTypeId >= 230 && CompartTypeId <= 232 || CompartTypeId === 236 || CompartTypeId === 237 || CompartTypeId === 240 )
  {// Link, Bushing, Shoe, Sprocket
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
     
  } 
  if(CompartTypeId == 446)
      return 'Rear'
  return Pos.toString();

}
}
